module.exports = __webpack_public_path__ + "img/图3@2x.8deae7c2.png";